export default __webpack_public_path__ + "static/media/search_black_24dp.6c95e853.svg";